import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SecurityRequestService {

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    private router: Router
  ) { }


  get2(url: string): Observable<any> {
    return of({})
      .pipe(
        switchMap(request => this.authService.AcquireTokenSilent()),
        map(request => {
          return Object.assign({}, {
            headers: new HttpHeaders().set('Authorization', `Bearer ${request.accessToken}`)
          });
        }),
        switchMap(options1 => this.httpClient.get(url)));
  }

  get(url: string, options?: any): Observable<any> {

    return this.sendRequest("GET", url, options);

  }

  delete(url: string, options?: any): Observable<any> {

    return this.sendRequest("DELETE", url, options);

  }

  remove(url: string, doby: any, options?: any): Observable<any> {

    let options1: any = {
      body: doby
    };

    options1 = Object.assign({}, options, options1);
    return this.sendRequest("DELETE", url, options1);

  }

  post(url: string, doby: any, options?: any): Observable<any> {

    let options1: any = {
      body: doby
    };

    options1 = Object.assign({}, options, options1);
    return this.sendRequest("POST", url, options1);
  }

  put(url: string, doby: any, options?: any): Observable<any> {

    let options1: any = {
      body: doby
    };

    options1 = Object.assign({}, options, options1);
    return this.sendRequest("PUT", url, options1);
  }

  private sendRequest(method: string, url: string, options?: any): Observable<any> {
    return of({})
      .pipe(
        switchMap(() => this.authService.AcquireTokenSilent()),
        map(request => {
          return Object.assign({}, options, {
            headers: new HttpHeaders().set('Authorization', `Bearer ${request.accessToken}`)
          });
        }),
        switchMap(options1 => this.httpClient.request(method, url, options1)),
        catchError(error => {
          if ([401, 403].includes(error.status)) {
            this.router.navigateByUrl('/login');
          }

          return throwError(() => error)
        })
      );
  }
}
